export class StepConfigurationHelper {
    // In the future this could go to another place so the helper could be more generic
    // And the helper would be instantiated with the page/app specific configuration
    static STEP_CONFIGURATION = [
        {
            id: 'lines',
            label: 'Configurar Linhas',
            dataType: 'lines',
            render: 'renderLineSelection',
            isNextDisabled: (state) => {
                const { form } = state;
                const hasSchematicMapComponent = form.layout &&
                    Array.isArray(form.layout.components) &&
                    form.layout.components.some(c => c.type === "SchematicMap");

                return form.lines.length === 0 || !hasSchematicMapComponent || form.layout === undefined;
            },
            onNext: (component) => {
                const { form } = component.state;
                component.getPaths(form.lines);
            }
        },
        {
            id: 'paths',
            label: 'Configurar Percursos',
            dataType: 'paths',
            render: 'renderPathSelection',
            isNextDisabled: (state) => state.form.paths.length === 0,
            onNext: (component) => {
                const { form } = component.state;
                component.getPoints(form.paths, form.pointType);
            },
        },
        {
            id: 'colors',
            label: 'Configurar Cores',
            dataType: null,
            render: 'renderLineColorSelection',
            isNextDisabled: () => false,
            onNext: null
        },
        {
            id: 'points',
            label: 'Configurar Pontos',
            dataType: 'points',
            render: 'renderPointSelection',
            isNextDisabled: (state) => {
                return state.form.points.length === 0;
            },
            onNext: (component) => {
                const { form } = component.state;
                component.getPathsShapes(form.paths);
            },
            substeps: [
                {
                    id: 'points-selection',
                    label: 'Selecionar Pontos para a Legenda',
                    render: 'renderPointCaptionSelection',
                    isNextDisabled: () => false,
                    onNext: null,
                    shouldInclude: (state) => {
                        const { form } = state;
                        return form.layout &&
                            Array.isArray(form.layout.components) &&
                            form.layout.components.some(c => c.type === "PointCaption") && form.pointType === 0;
                    }
                },
            ]
        },
        {
            id: 'summary',
            label: 'Resumo',
            dataType: null,
            render: 'renderSummary',
            isNextDisabled: () => false,
            onNext: (component) => {
                component.generateMap();
            }
        },
        {
            id: 'result',
            label: 'Geração',
            dataType: null,
            render: 'renderResult',
            isNextDisabled: (state) => state.render.result === undefined,
            onNext: (component) => {
                component.onDownloadClick();
            }
        }
    ];


    static getFilteredSubsteps(step, state) {
        if (!step.substeps) {
            return [];
        }

        return step.substeps.filter(substep => {
            if (substep.shouldInclude) {
                return substep.shouldInclude(state);
            }

            return true; // Include by default if no condition
        });
    }

    static getCurrentStepConfig(stepIndex, substepIndex, state) {
        const mainStep = this.STEP_CONFIGURATION[stepIndex];
        if (!mainStep) {
            return null;
        }

        if (substepIndex === null || substepIndex === undefined) {
            return mainStep;
        }

        const filteredSubsteps = this.getFilteredSubsteps(mainStep, state);
        return filteredSubsteps[substepIndex] || null;
    }

    static hasAvailableSubsteps(stepIndex, state) {
        const mainStep = this.STEP_CONFIGURATION[stepIndex];
        if (!mainStep) {
            return false;            
        }

        const filteredSubsteps = this.getFilteredSubsteps(mainStep, state);
        return filteredSubsteps.length > 0;
    }

    static getSubstepCount(stepIndex, state) {
        const mainStep = this.STEP_CONFIGURATION[stepIndex];
        if (!mainStep) {
            return 0;
        }

        return this.getFilteredSubsteps(mainStep, state).length;
    }

    static getTotalSteps() {
        return this.STEP_CONFIGURATION.length;
    }

    static getRulerSteps() {
        return this.STEP_CONFIGURATION;
    }

    static isMainStepActive(mainStepIndex, currentStepIndex) {
        return mainStepIndex === currentStepIndex;
    }

    static isMainStepCompleted(mainStepIndex, currentStepIndex) {
        return mainStepIndex < currentStepIndex;
    }
}